const useAvatar = (
  fullName?: string,
  defaultVal: string = 'John Doe'
): string | null => {
  const val = fullName || defaultVal
  const matches = val.match(/\b(\w)/g)

  if (!matches) {
    return null
  }

  const handle = (arr: Array<string>) => {
    return arr.slice(0, 2).join('').toLocaleUpperCase()
  }

  if (matches.length === 1) {
    return handle(val.split(''))
  }

  return handle(matches)
}

export default useAvatar
